/**
 * Custom font registration utilities.
 * Pure helpers are re-exported from @course-authoring/shared-types.
 * loadAndRegisterFont stays here (DOM-specific, not shared with the player).
 */

// Re-export pure font-name helpers for backward compatibility.
export { themeFontFamilyName, themeFontCss, fontFaceDescriptors } from '@course-authoring/shared-types';

/**
 * Load a FontFace from a URL or binary buffer and register it with the
 * document font set. `descriptors` (see fontFaceDescriptors) declares the
 * font's supported weights so bold is not synthesized.
 */
export function loadAndRegisterFont(
  familyName: string,
  source: string | BufferSource,
  descriptors?: FontFaceDescriptors,
): Promise<void> {
  const fontFace = new FontFace(familyName, source, descriptors);
  return fontFace.load().then((loaded) => {
    document.fonts.add(loaded);
  });
}
